// extracted by mini-css-extract-plugin
export default {"bottomButton":"nrxpB","clickable":"yQO1m","arrow":"TcTDR","isLight":"LeF8q"};